﻿import axios from "axios";

const notificationService = {
   
    obtenerNotificaciones: async (idAfiliado: string) => {
        try {          
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/Notifications/getNotifications/${idAfiliado}`
            );
            return response.data;
        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    },
    updateNotificationsStatus: async (idNotificacion: string) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/api/Notifications/updateNotificationsStatus/${idNotificacion}`
            );

            return response.data;

        } catch (error: any) {
            throw error.response ? error.response.data : error.message;
        }
    }
};


export default notificationService

